exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".file-invalid{color:red;text-align:center}.file-item{font-size:1.5rem}#input-9{padding-top:.25rem;padding-bottom:.25rem}", ""]);

// exports
